import { SEASON_BADGES_FAILURE, SEASON_BADGES_SUCCESS, SEASON_BADGES_LOADING, UPDATE_SELECTED_TEAM } from 'redux/reduxConstants';
import { Badge } from 'redux/models/badge';
interface TeamBadgesState {
	teamId: string;
	currentSeasonId: string;
	selectedSeasonBadges: Badge[];
	badgesLoading: boolean;
	error: string;
}

const teamBadgesState: TeamBadgesState = {
	teamId: '',
	currentSeasonId: '',
	selectedSeasonBadges: [],
	badgesLoading: false,
	error: '',
};

const teamBadges = (state = teamBadgesState, action: any) => {
	switch (action.type) {
		case SEASON_BADGES_LOADING:
			let teamBadgesState = { ...state };
			teamBadgesState.currentSeasonId = action.seasonId;
			teamBadgesState.badgesLoading = true;
			return teamBadgesState;
		case SEASON_BADGES_SUCCESS:
			let teamBadgesSuccessState = { ...state };
			teamBadgesSuccessState.badgesLoading = false;
			teamBadgesSuccessState.selectedSeasonBadges = action.badges;
			teamBadgesSuccessState.error = '';
			return teamBadgesSuccessState;
		case SEASON_BADGES_FAILURE:
			let teamBadgesFailureState = { ...state };
			teamBadgesFailureState.badgesLoading = false;
			teamBadgesFailureState.error = action.error;
			return teamBadgesFailureState;
		case UPDATE_SELECTED_TEAM:
			let updateSelectedTeamState = { ...state };
			updateSelectedTeamState.teamId = action.teamId;
			updateSelectedTeamState.error = action.error;
			return updateSelectedTeamState;
		default:
			return state;
	}
};

export default teamBadges;
